import { z } from "zod";

export const ForgotPasswordSchema = z.object({
  email: z.string().email({ message: "Invalid email address" }),
});

export type ForgotPasswordModel = z.infer<typeof ForgotPasswordSchema>;